import React from 'react';
import { Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { MarketField, MarketInputText } from '@market/react';

const ControlledInputText = (props) => {
  const { t } = useTranslation();

  const {
    // fields used by Controller
    name,
    control,
    defaultValue,
    rules,
    shouldUnregister = false,

    // fields used by Market
    disabled = false,
    label,
    placeholder,
    maxlength,
    minlength,
    transform = (input) => input,
    cta,
    children,
  } = props;

  // small hack because `required` doesn't doesn't do a whitespace check
  if (rules?.required) {
    rules.validate = (value) => Boolean(value.trim());
  }

  return (
    <Controller
      name={name}
      control={control}
      defaultValue={defaultValue || ''}
      rules={rules}
      shouldUnregister={shouldUnregister}
      render={({
        field: { value, onChange },
        fieldState: { invalid, error },
        formState: { isSubmitting, isValidating },
      }) => (
        <>
          <MarketField
            {...((disabled || isSubmitting || isValidating) && {
              disabled: true,
            })}
            name={name}
            invalid={invalid}
          >
            <MarketInputText
              name={name}
              value={value}
              placeholder={placeholder}
              maxlength={maxlength}
              minlength={minlength}
              onMarketInputValueChange={(e) => {
                const userInput = e.detail.value;
                const transformedInput = transform(userInput);
                // eslint-disable-next-line no-param-reassign
                e.target.shadowRoot.querySelector('input').value =
                  transformedInput;
                onChange(transformedInput);
              }}
            >
              {label && <label>{label}</label>}
              {children}
            </MarketInputText>
            <small slot="error">
              {error?.message || t('error.validation.invalidValue')}
            </small>
          </MarketField>
          {cta && <span>{cta}</span>}
        </>
      )}
    />
  );
};

export default ControlledInputText;
